/* WebNest — react-hot-toast renderer styled to match the Help Center ("support")
   toast the team standardised on: a clean pill with a tone-coloured icon, the
   message, and a soft drop shadow. react-hot-toast stays the engine (all existing
   toast.success/error/loading calls work unchanged). Leans on design tokens in
   index.css. */
import React, { useEffect } from 'react'
import { Icon } from './ns-icons'

/* react-hot-toast type → icon + colour */
const TONE = {
  success: { color: 'var(--success)', icon: 'check' },
  error:   { color: 'var(--danger)',  icon: 'x' },
  loading: { color: 'var(--accent)',  icon: 'bolt' },
  blank:   { color: 'var(--success)', icon: 'check' },
}

function injectStyles() {
  if (typeof document === 'undefined' || document.getElementById('ns-toast-style')) return
  const el = document.createElement('style')
  el.id = 'ns-toast-style'
  el.textContent = `
    @keyframes nsToastIn  { from { opacity: 0; transform: translateY(14px) scale(0.98); }
                            to   { opacity: 1; transform: translateY(0) scale(1); } }
    @keyframes nsToastOut { from { opacity: 1; transform: translateY(0) scale(1); }
                            to   { opacity: 0; transform: translateY(10px) scale(0.98); } }`
  document.head.appendChild(el)
}

export function NSHotToast({ t }) {
  useEffect(injectStyles, [])

  const tone = TONE[t.type] || TONE.blank
  const isLoading = t.type === 'loading'
  const msg = typeof t.message === 'function' ? t.message(t) : t.message

  return (
    <div
      {...t.ariaProps}
      role="status"
      style={{
        pointerEvents: 'auto',
        display: 'flex', alignItems: 'center', gap: 9,
        padding: '11px 18px',
        maxWidth: 'min(360px, calc(100vw - 32px))',
        background: 'var(--bg-2)', border: '1px solid var(--border-strong)',
        borderRadius: 12, boxShadow: 'var(--shadow-lg, 0 18px 50px -12px rgba(0,0,0,0.6))',
        fontSize: 13, fontWeight: 500, color: 'var(--text)', lineHeight: 1.4,
        animation: t.visible
          ? 'nsToastIn 0.26s cubic-bezier(0.22,1,0.36,1) both'
          : 'nsToastOut 0.2s ease forwards',
      }}
    >
      <span style={{ display: 'inline-flex', flexShrink: 0, color: tone.color, fontSize: 16 }}>
        {isLoading
          ? <span style={{ width: 14, height: 14, border: '2px solid var(--border-strong)', borderTopColor: tone.color, borderRadius: '50%', display: 'inline-block', animation: 'spin 0.6s linear infinite' }} />
          : <Icon name={tone.icon} />}
      </span>
      <span style={{ minWidth: 0, wordBreak: 'break-word' }}>{msg}</span>
    </div>
  )
}
